module.exports = __webpack_public_path__ + "static/media/notification.70841bdd.svg";